import { Sources } from 'common/enums/source';

export const isSource = (
  value: string,
): value is Sources => Object.values<string>(Sources).includes(value);
